module.exports = __webpack_public_path__ + "static/media/Main.style.9844bbf6.scss";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/pages/Main/Main.style.scss
// module id = 868
// module chunks = 0